// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/zryWPy3qSlufEB_XKiilag

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';

import Icon from 'components/Icon';

const slotIcons = {
	image: 'photo',
	text: 'keyboard',
	pictogram: 'tag',
};

const Container = styled.div`
	display: block;
	position: relative;
	width: 100%;
	height: 100%;

	&:after {
		content: "";
		position: absolute;
		top: -6px;
		left: -6px;
		width: calc(100% + 8px);
		height: calc(100% + 8px);
		background-color: rgba(74,144,226,${params => params.highlight ? 0.3 : 0.05});
		border: 2px solid ${params => params.highlight ? 'rgba(0,0,0,0)' : '#4A90E2'};
		border-radius: 4px;
		opacity: ${params => params.highlight || params.active ? 1 : 0};
		transition: opacity 0.2s ease-out;
		pointer-events: none;
	}

	&:hover {
		cursor: ${params => params.editable ? 'pointer' : 'normal'};

		&:after {
			opacity: ${params => params.editable ? '1' : '0'};
		}
	}
`;

const SlotIcon = styled(Icon)`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 20px;
	height: 20px;
	display: ${params => params.highlight};
	background-color: white;
	border-radius: 2px;

	svg {
		fill: rgba(74,144,226, 1);
	}
`;

const Slot = props => {
	const {
		type,
		index,
		children,
		active,
		highlight,
		options,
		editable: isEditable
	} = props;

	const layout = 'layout' in options ? ' b-slot-layout-' + options.layout : '';

	let className = 'b-slot b-slot-' + type + layout;

	const style = {
		backgroundColor: options['background-color'],
	};

	if (options['background-color'] !== 'rgba(255,255,255,0)') {
		style.border = '0';
	}

	const childrenWithProps = React.Children.map(children, child => React.cloneElement(child, { slotActive: active }));
	let editable = !!isEditable;

	switch (type) {
	case 'contacts':
	case 'accessibility':
	case 'buildingProperties':
		editable = false;
		break;
	default:
		break;
	}

	return editable ? (
		<Droppable
			droppableId={props.id}
		>
			{(provided) => (
				<Container
					className={className}
					style={style}
					editable={editable}
					data-index={index}
					active={active}
					highlight={highlight}
					onClick={props.activeSlotHandler}
					innerRef={provided.innerRef}
					{...provided.droppableProps}
				>
					{childrenWithProps}
					<SlotIcon
						className="icon"
						icon={slotIcons[type]}
						highlight={highlight ? 'block' : 'none'}
					/>
					{provided.placeholder}
				</Container>
			)}
		</Droppable>
	) : (
		<Container className={className} data-index={index}>
			{childrenWithProps}
		</Container>
	)
}

Slot.propTypes = {
	id: PropTypes.string,
	children: PropTypes.element,
	type: PropTypes.string,
	index: PropTypes.number,
	active: PropTypes.bool,
	highlight: PropTypes.bool,
	options: PropTypes.object,
	editable: PropTypes.bool,
	activeSlotHandler: PropTypes.func,
}

Slot.defaultProps = {
	id: '',
	children: null,
	type: 'image',
	index: 0,
	active: false,
	highlight: false,
	editable: true,
	activeSlotHandler: () => {}
}

export default Slot;
